import React from "react";
import { Reveal, CTAButton, TrustBadges } from "./ui";
const lines = ["Cada crisis.", "Cada discusión.", "Cada mañana caótica.", "Cada noche sintiendo que te faltan herramientas."];
export function EmotionalHit() {
  return <section className="w-full bg-[var(--ink)] px-4 py-12 text-white sm:px-8 sm:py-28" data-id="element-48" data-mp="jp4fong9j65h">
      <div className="mx-auto max-w-3xl text-center" data-id="element-49" data-mp="or3hhswctv0b">
        <Reveal data-id="element-50" data-mp="tp51cg1ltycu">
          <h2 className="font-serif-display text-3xl font-semibold leading-tight sm:text-4xl" data-id="element-51" data-mp="tpepdy339vfw">
            ¿Cuántos días más vas a seguir improvisando?
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-52" data-mp="13dwped3jnyih">
          <div className="mt-5 space-y-1 text-base text-white/70 sm:mt-8 sm:space-y-2 sm:text-lg" data-id="element-53" data-mp="13fpv9q6c2epf">
            {lines.map(l => <p key={l} data-id="element-54" data-mp="17i4iemh1c0mi">{l}</p>)}
          </div>
        </Reveal>
        <Reveal delay={0.2} data-id="element-55" data-mp="1cgo4cmvmpcev">
          <p className="mx-auto mt-5 max-w-xl text-base text-white/90 sm:mt-8 sm:text-lg" data-id="element-56" data-mp="1cda2rgush78h">
            Todo eso desgasta a tu hijo. Y también te desgasta a vos.
          </p>
        </Reveal>
        <Reveal delay={0.3} className="mt-7 sm:mt-10" data-id="element-57" data-mp="x762s6ul520w">
          <CTAButton className="!bg-white !text-[var(--ink)] hover:!bg-white/90" data-id="element-58" data-mp="s9ea3am49bvn">
            Quiero empezar hoy
          </CTAButton>
        </Reveal>
      </div>
    </section>;
}